<template>
  <v-card flat height="75%">
    <v-card-text class="px-0">
      <v-data-table-virtual
        hide-default-header
        hide-default-footer
        disable-pagination
        disable-sort
        show-expand
        item-key="id"
        height="90%"
        :group-by="[{ key: 'sortDate', order: 'desc' }]"
        :expanded.sync="expanded"
        :headers="headers"
        :items="logLines"
        :search="searchStr">
        <template v-slot:group-header="{ item: group, columns, isGroupOpen, toggleGroup }">
          <!-- Vuetify 3 hack to open all groups by default -->
          <template
            :ref="
              el => {
                if (!isGroupOpen(group)) toggleGroup(group);
              }
            "></template>
          <tr>
            <th :colspan="columns.length">
              <strong>
                <v-icon size="small" class="mr-2" @click="toggleGroup(group)">mdi-calendar</v-icon>
                {{ group.items[0].raw.date }}
              </strong>
            </th>
          </tr>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.value="{ item }"></template>
        <template v-slot:item.date="{ item }"></template>
        <template v-slot:item.field="{ item }">
          <strong>{{ item.field }}</strong>
          {{ item.action }}
        </template>
        <template v-slot:item.user="{ item }">
          <strong class="text--disabled">by {{ item.user }}</strong>
        </template>
        <template v-slot:expanded-row="{ columns, item }">
          <tr>
            <td :colspan="columns.length" class="py-4">
              <pre class="expanded" v-html="item.value"></pre>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <tr>
            <td :colspan="headers.length">No matching records found.</td>
          </tr>
        </template>
      </v-data-table-virtual>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    logLines: {
      type: Array,
      required: true
    },
    timezone: {
      type: String,
      required: false
    },
    searchStr: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      expanded: [],
      headers: [
        {
          value: 'time',
          align: 'start',
          sortable: false
        },
        {
          value: 'field',
          sortable: false
        },
        {
          value: 'user',
          align: 'end',
          sortable: false
        },
        {
          value: 'value',
          sortable: false
        },
        {
          value: 'date',
          sortable: false
        }
      ]
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss">
.expanded {
  overflow-y: hidden;
  max-width: 100%;
  white-space: pre-wrap;
  font-size: 12px;
}
</style>
